import { setHideTrash } from './chatFilterSetters';
const updateTrashToggle = (filters, filterValue) => {
  return setHideTrash(filterValue, filters);
};
export default updateTrashToggle;